module.exports = __webpack_public_path__ + "media/3-1.f92b1592.wav";